import { Component, OnInit } from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from '../auth.service';
import { ChangeLanguageComponent } from '../dialogs/change-language/change-language.component';
import { User } from '../models/user';
import { NavBarComponent } from '../nav-bar/nav-bar.component';

import {ConfirmProfileDeleteComponent} from '../dialogs/confirm-profile-delete/confirm-profile-delete.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ManagementService } from '../services/management.service';
import { Base } from '../services/base';
import { updatePassword } from 'aws-amplify/auth';

interface Currency {
  value: string;
  viewValue: string;
}

interface Landing {
  value: string;
  viewValue: string;
}

interface Language {
  value: string;
  viewValue: string;
}

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css'],
    standalone: false
})

export class ProfileComponent implements OnInit {

  /** Direction A layout: identity header + tabs. */
  activeTab: 'profile' | 'preferences' | 'security' | 'account' = 'profile';
  readonly tabs: { id: 'profile' | 'preferences' | 'security' | 'account'; label: string }[] = [
    { id: 'profile', label: 'PROFILE.TAB-PROFILE' },
    { id: 'preferences', label: 'PROFILE.TAB-PREFERENCES' },
    { id: 'security', label: 'PROFILE.TAB-SECURITY' },
    { id: 'account', label: 'PROFILE.TAB-ACCOUNT' }
  ];

  public user: User;
  public error: boolean;
  public nameReq;
  public nameLenght;
  public surnameReq;
  public surnameLength;
  public confirmPass;
  public newPassReq;
  public newPassLength;
  public cellReq;
  public cellPattern;
  passwordErrorMessage: string = '';
  showPasswords = {
    oldPassword: false,
    newPassword: false,
    confirmPassword: false
  }

  personalForm = new FormGroup({
    name: new FormControl('', Validators.compose([
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(50),
      Validators.pattern(/^((?!\s{2,}).)*$/)
    ])),
    surname: new FormControl('', Validators.compose([
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(50),
      Validators.pattern(/^((?!\s{2,}).)*$/)
    ]))
  });

  passwordForm = new FormGroup({
    newPassword: new FormControl('', Validators.compose([
      Validators.minLength(5),
      Validators.required,
      Validators.pattern(/^\S*$/),
      Validators.pattern(/^(?=\S{8,}$)(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&^_-]).+$/)
    ])),
    confirmPassword: new FormControl('', Validators.required),
    oldPassword: new FormControl('', Validators.required)
  },  { validators: this.matchValidator('newPassword', 'confirmPassword') });

  contactForm = new FormGroup({
    cell: new FormControl('', Validators.compose([
      Validators.required,
      Validators.pattern('[0-9 ]{10}')
    ]))
  });

  currencyForm = new FormGroup({
    currency: new FormControl(''),
    landing: new FormControl('')
  });

  languageForm = new FormGroup({
    language: new FormControl('')
  });

  areEqual(formGroup: FormGroup) {
    let value;
    let valid = true;
    for (let key in formGroup.controls) {
      if (formGroup.controls.hasOwnProperty(key)) {
        let control: FormControl = <FormControl>formGroup.controls[key];

        if (value === undefined) {
          value = control.value
        } else {
          if (value !== control.value) {
            valid = false;
            break;
          }
        }
      }
    }

    if (valid) {
      return null;
    }

    return {
      areEqual: true
    };
  }

  selectedCurrency: string;
  selectedLanding: string;
  selectedLanguage: string;


  currencies: Currency[] = [{ value: 'ADP', viewValue: 'ADP' }, { value: 'AED', viewValue: 'AED' }, { value: 'AFA', viewValue: 'AFA' }, { value: 'AFN', viewValue: 'AFN' }, { value: 'ALL', viewValue: 'ALL' }, { value: 'AMD', viewValue: 'AMD' },
  { value: 'ANG', viewValue: 'ANG' }, { value: 'AOA', viewValue: 'AOA' }, { value: 'ARS', viewValue: 'ARS' }, { value: 'ATS', viewValue: 'ATS' }, { value: 'AUD', viewValue: 'AUD' }, { value: 'AWG', viewValue: 'AWG' },
  { value: 'AYM', viewValue: 'AYM' }, { value: 'AZM', viewValue: 'AZM' }, { value: 'AZN', viewValue: 'AZN' }, { value: 'BAM', viewValue: 'BAM' }, { value: 'BBD', viewValue: 'BBD' }, { value: 'BDT', viewValue: 'BDT' },
  { value: 'BEF', viewValue: 'BEF' }, { value: 'BGL', viewValue: 'BGL' }, { value: 'BGN', viewValue: 'BGN' }, { value: 'BHD', viewValue: 'BHD' }, { value: 'BIF', viewValue: 'BIF' }, { value: 'BMD', viewValue: 'BMD' },
  { value: 'BND', viewValue: 'BND' }, { value: 'BOB', viewValue: 'BOB' }, { value: 'BOV', viewValue: 'BOV' }, { value: 'BRL', viewValue: 'BRL' }, { value: 'BSD', viewValue: 'BSD' }, { value: 'BTN', viewValue: 'BTN' },
  { value: 'BWP', viewValue: 'BWP' }, { value: 'BYB', viewValue: 'BYB' }, { value: 'BYR', viewValue: 'BYR' }, { value: 'BZD', viewValue: 'BZD' }, { value: 'CAD', viewValue: 'CAD' }, { value: 'CDF', viewValue: 'CDF' },
  { value: 'CHF', viewValue: 'CHF' }, { value: 'CLF', viewValue: 'CLF' }, { value: 'CLP', viewValue: 'CLP' }, { value: 'CNY', viewValue: 'CNY' }, { value: 'COP', viewValue: 'COP' }, { value: 'CRC', viewValue: 'CRC' },
  { value: 'CSD', viewValue: 'CSD' }, { value: 'CUC', viewValue: 'CUC' }, { value: 'CUP', viewValue: 'CUP' }, { value: 'CVE', viewValue: 'CVE' }, { value: 'CYP', viewValue: 'CYP' }, { value: 'CZK', viewValue: 'CZK' },
  { value: 'DEM', viewValue: 'DEM' }, { value: 'DJF', viewValue: 'DJF' }, { value: 'DKK', viewValue: 'DKK' }, { value: 'DOP', viewValue: 'DOP' }, { value: 'DZD', viewValue: 'DZD' }, { value: 'EEK', viewValue: 'EEK' },
  { value: 'EGP', viewValue: 'EGP' }, { value: 'ERN', viewValue: 'ERN' }, { value: 'ESP', viewValue: 'ESP' }, { value: 'ETB', viewValue: 'ETB' }, { value: 'EUR', viewValue: 'EUR' }, { value: 'FIM', viewValue: 'FIM' },
  { value: 'FJD', viewValue: 'FJD' }, { value: 'FKP', viewValue: 'FKP' }, { value: 'FRF', viewValue: 'FRF' }, { value: 'GBP', viewValue: 'GBP' }, { value: 'GEL', viewValue: 'GEL' }, { value: 'GHC', viewValue: 'GHC' },
  { value: 'GHS', viewValue: 'GHS' }, { value: 'GIP', viewValue: 'GIP' }, { value: 'GMD', viewValue: 'GMD' }, { value: 'GNF', viewValue: 'GNF' }, { value: 'GRD', viewValue: 'GRD' }, { value: 'GTQ', viewValue: 'GTQ' },
  { value: 'GWP', viewValue: 'GWP' }, { value: 'GYD', viewValue: 'GYD' }, { value: 'HKD', viewValue: 'HKD' }, { value: 'HNL', viewValue: 'HNL' }, { value: 'HRK', viewValue: 'HRK' }, { value: 'HTG', viewValue: 'HTG' },
  { value: 'HUF', viewValue: 'HUF' }, { value: 'IDR', viewValue: 'IDR' }, { value: 'IEP', viewValue: 'IEP' }, { value: 'ILS', viewValue: 'ILS' }, { value: 'INR', viewValue: 'INR' }, { value: 'IQD', viewValue: 'IQD' },
  { value: 'IRR', viewValue: 'IRR' }, { value: 'ISK', viewValue: 'ISK' }, { value: 'ITL', viewValue: 'ITL' }, { value: 'JMD', viewValue: 'JMD' }, { value: 'JOD', viewValue: 'JOD' }, { value: 'JPY', viewValue: 'JPY' },
  { value: 'KES', viewValue: 'KES' }, { value: 'KGS', viewValue: 'KGS' }, { value: 'KHR', viewValue: 'KHR' }, { value: 'KMF', viewValue: 'KMF' }, { value: 'KPW', viewValue: 'KPW' }, { value: 'KRW', viewValue: 'KRW' },
  { value: 'KWD', viewValue: 'KWD' }, { value: 'KYD', viewValue: 'KYD' }, { value: 'KZT', viewValue: 'KZT' }, { value: 'LAK', viewValue: 'LAK' }, { value: 'LBP', viewValue: 'LBP' }, { value: 'LKR', viewValue: 'LKR' },
  { value: 'LRD', viewValue: 'LRD' }, { value: 'LSL', viewValue: 'LSL' }, { value: 'LTL', viewValue: 'LTL' }, { value: 'LUF', viewValue: 'LUF' }, { value: 'LVL', viewValue: 'LVL' }, { value: 'LYD', viewValue: 'LYD' },
  { value: 'MAD', viewValue: 'MAD' }, { value: 'MDL', viewValue: 'MDL' }, { value: 'MGA', viewValue: 'MGA' }, { value: 'MGF', viewValue: 'MGF' }, { value: 'MKD', viewValue: 'MKD' }, { value: 'MMK', viewValue: 'MMK' },
  { value: 'MNT', viewValue: 'MNT' }, { value: 'MOP', viewValue: 'MOP' }, { value: 'MRO', viewValue: 'MRO' }, { value: 'MTL', viewValue: 'MTL' }, { value: 'MUR', viewValue: 'MUR' }, { value: 'MVR', viewValue: 'MVR' },
  { value: 'MWK', viewValue: 'MWK' }, { value: 'MXN', viewValue: 'MXN' }, { value: 'MXV', viewValue: 'MXV' }, { value: 'MYR', viewValue: 'MYR' }, { value: 'MZM', viewValue: 'MZM' }, { value: 'MZN', viewValue: 'MZN' },
  { value: 'NAD', viewValue: 'NAD' }, { value: 'NGN', viewValue: 'NGN' }, { value: 'NIO', viewValue: 'NIO' }, { value: 'NLG', viewValue: 'NLG' }, { value: 'NOK', viewValue: 'NOK' }, { value: 'NPR', viewValue: 'NPR' },
  { value: 'NZD', viewValue: 'NZD' }, { value: 'OMR', viewValue: 'OMR' }, { value: 'PAB', viewValue: 'PAB' }, { value: 'PEN', viewValue: 'PEN' }, { value: 'PGK', viewValue: 'PGK' }, { value: 'PHP', viewValue: 'PHP' },
  { value: 'PKR', viewValue: 'PKR' }, { value: 'PLN', viewValue: 'PLN' }, { value: 'PTE', viewValue: 'PTE' }, { value: 'PYG', viewValue: 'PYG' }, { value: 'QAR', viewValue: 'QAR' }, { value: 'ROL', viewValue: 'ROL' },
  { value: 'RON', viewValue: 'RON' }, { value: 'RSD', viewValue: 'RSD' }, { value: 'RUB', viewValue: 'RUB' }, { value: 'RUR', viewValue: 'RUR' }, { value: 'RWF', viewValue: 'RWF' }, { value: 'SAR', viewValue: 'SAR' },
  { value: 'SBD', viewValue: 'SBD' }, { value: 'SCR', viewValue: 'SCR' }, { value: 'SDD', viewValue: 'SDD' }, { value: 'SDG', viewValue: 'SDG' }, { value: 'SEK', viewValue: 'SEK' }, { value: 'SGD', viewValue: 'SGD' },
  { value: 'SHP', viewValue: 'SHP' }, { value: 'SIT', viewValue: 'SIT' }, { value: 'SKK', viewValue: 'SKK' }, { value: 'SLL', viewValue: 'SLL' }, { value: 'SOS', viewValue: 'SOS' }, { value: 'SRD', viewValue: 'SRD' },
  { value: 'SRG', viewValue: 'SRG' }, { value: 'SSP', viewValue: 'SSP' }, { value: 'STD', viewValue: 'STD' }, { value: 'SVC', viewValue: 'SVC' }, { value: 'SYP', viewValue: 'SYP' }, { value: 'SZL', viewValue: 'SZL' },
  { value: 'THB', viewValue: 'THB' }, { value: 'TJS', viewValue: 'TJS' }, { value: 'TJS', viewValue: 'TJS' }, { value: 'TMM', viewValue: 'TMM' }, { value: 'TMT', viewValue: 'TMT' }, { value: 'TND', viewValue: 'TND' },
  { value: 'TOP', viewValue: 'TOP' }, { value: 'TPE', viewValue: 'TPE' }, { value: 'TRL', viewValue: 'TRL' }, { value: 'TRY', viewValue: 'TRY' }, { value: 'TTD', viewValue: 'TTD' }, { value: 'TWD', viewValue: 'TWD' },
  { value: 'TZS', viewValue: 'TZS' }, { value: 'UAH', viewValue: 'UAH' }, { value: 'UGX', viewValue: 'UGX' }, { value: 'USD', viewValue: 'USD' }, { value: 'USN', viewValue: 'USN' }, { value: 'USS', viewValue: 'USS' },
  { value: 'UYU', viewValue: 'UYU' }, { value: 'UZS', viewValue: 'UZS' }, { value: 'VEB', viewValue: 'VEB' }, { value: 'VEF', viewValue: 'VEF' }, { value: 'VND', viewValue: 'VND' }, { value: 'VUV', viewValue: 'VUV' },
  { value: 'WST', viewValue: 'WST' }, { value: 'XAF', viewValue: 'XAF' }, { value: 'XAG', viewValue: 'XAG' }, { value: 'XAU', viewValue: 'XAU' }, { value: 'XBA', viewValue: 'XBA' }, { value: 'XBB', viewValue: 'XBB' },
  { value: 'XBC', viewValue: 'XBC' }, { value: 'XBD', viewValue: 'XBD' }, { value: 'XCD', viewValue: 'XCD' }, { value: 'XDR', viewValue: 'XDR' }, { value: 'XFO', viewValue: 'XFO' }, { value: 'XFU', viewValue: 'XFU' },
  { value: 'XOF', viewValue: 'XOF' }, { value: 'XPD', viewValue: 'XPD' }, { value: 'XPF', viewValue: 'XPF' }, { value: 'XPT', viewValue: 'XPT' }, { value: 'XSU', viewValue: 'XSU' }, { value: 'XTS', viewValue: 'XTS' },
  { value: 'XUA', viewValue: 'XUA' }, { value: 'XXX', viewValue: 'XXX' }, { value: 'YER', viewValue: 'YER' }, { value: 'YUM', viewValue: 'YUM' }, { value: 'ZAR', viewValue: 'ZAR' }, { value: 'ZMK', viewValue: 'ZMK' },
  { value: 'ZMW', viewValue: 'ZMW' }, { value: 'ZWD', viewValue: 'ZWD' }, { value: 'ZWL', viewValue: 'ZWL' }, { value: 'ZWN', viewValue: 'ZWN' }, { value: 'ZWR', viewValue: 'ZWR' }
  ];

  landings: Landing[] = [{ value: 'dashboard', viewValue: 'Dashboard' }, { value: 'mapping', viewValue: 'Mapping' }, { value: 'virtual-consultant', viewValue: 'Virtual consultant' }];

  siteLanguage: string;
  siteLocale: string;
  languageList = [
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Spanish' },
    { code: 'tr', label: 'Turkish' }
  ];

  constructor(public auth: AuthService,
    public base: Base,
    public managementService: ManagementService,
    private _snackBar: MatSnackBar,
    public nav: NavBarComponent,
    public cookieService: CookieService,
    public dialog: MatDialog,
    public translate: TranslateService) {

    this.nav.toggleLoading(false);

    if (this.cookieService.get('default-language') != '') {
      this.selectedLanguage = this.cookieService.get('default-language')
    } else {
      this.selectedLanguage = 'en';
    }


    this.getUserProfileInfo();

  }

  ngOnInit() {``
  }

  matchValidator(controlName: string, matchingControlName: string): ValidatorFn {
    return (abstractControl: AbstractControl) => {
      const control = abstractControl.get(controlName);
      const matchingControl = abstractControl.get(matchingControlName);

      if (matchingControl!.errors && !matchingControl!.errors?.['confirmedValidator']) {
        return null;
      }

      if (control!.value !== matchingControl!.value) {
        const error = {confirmedValidator: 'Passwords do not match.'};
        matchingControl!.setErrors(error);
        return error;
      } else {
        matchingControl!.setErrors(null);
        return null;
      }
    }
  }

  ngAfterViewInit() {
    this.getUserProfileInfo();

    setTimeout(() => {
      this.passwordForm.controls.newPassword.reset();
      this.passwordForm.controls.confirmPassword.reset();
    }, 3000);
  }

  updateUser() {
    this.user.name = this.personalForm.controls.name.value;
    this.user.surname = this.personalForm.controls.surname.value;
    this.user.cell = this.contactForm.controls.cell.value;
    this.user.currency = this.selectedCurrency;
    this.user.landingPage = this.selectedLanding;
    this.managementService.updateUser(this.user).subscribe((value => {
      this.nav.toggleLoading(true);
      this.openSnackBar(this.translate.instant("PROFILE.DETAILS-UPDATED"), this.translate.instant("SNACKBAR.DISMISS"));
      this.nav.name = this.user.name + ' ' + this.user.surname;
      let jsonUser = JSON.stringify(this.user);
      sessionStorage.setItem("user", jsonUser);
      this.nav.toggleLoading(false);
    }));
  }

  async updatePassword() {
    var newPass = this.passwordForm.controls.newPassword.value;
    var confirmPass = this.passwordForm.controls.confirmPassword.value;

    if (newPass != "" && confirmPass != "") {
      if (newPass == confirmPass) {
        this.passwordErrorMessage = "";
        this.user.password = newPass;
        this.nav.toggleLoading(true);
        await updatePassword({
          oldPassword: this.passwordForm.controls.oldPassword.value,
          newPassword: newPass
        }).then(() => {
          this.nav.toggleLoading(false);
        }).catch((error) => {
          if(error?.message.includes('Incorrect username or password')) {
            this.passwordErrorMessage = "The old password is incorrect";
          } else {
            this.passwordErrorMessage = error.message;
          }
          this.nav.toggleLoading(false);
        })
        // this.managementService.updatePassword(this.user).subscribe((value => {
        //   this.openSnackBar(this.translate.instant("PROFILE.PASSWORD-UPDATED"), this.translate.instant("SNACKBAR.DISMISS"));
        //   this.passwordForm.controls.newPassword.reset();
        //   this.passwordForm.controls.confirmPassword.reset();
        //   this.nav.toggleLoading(false);
        // }));
      } else {
        this.openSnackBar(this.translate.instant("PROFILE.PASSWORDS-DONT-MATCH"), this.translate.instant("SNACKBAR.DISMISS"));
        this.passwordForm.setValue({ newPassword: '', confirmPassword: '' , oldPassword: ''})
      }
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }

  get initials(): string {
    return ((this.user?.name?.charAt(0) || '') + (this.user?.surname?.charAt(0) || '')).toUpperCase();
  }

  // Per-card saves (replaces the shared onSubmit branching; updateUser still
  // PUTs the merged user, preserving the existing API contract).
  savePersonal(): void {
    if (this.personalForm.invalid) { this.personalForm.markAllAsTouched(); return; }
    this.nav.toggleLoading(true);
    this.updateUser();
  }

  saveContact(): void {
    if (this.contactForm.invalid) { this.contactForm.markAllAsTouched(); return; }
    this.nav.toggleLoading(true);
    this.updateUser();
  }

  savePreferences(): void {
    this.nav.toggleLoading(true);
    this.updateUser();
  }

  async savePassword(): Promise<void> {
    if (this.passwordForm.invalid) { this.passwordForm.markAllAsTouched(); return; }
    await this.updatePassword();
  }

  async onSubmit() {
    if (this.passwordForm.controls.newPassword.value == '' || this.passwordForm.controls.newPassword.value == null) {
      this.nav.toggleLoading(true);
      this.updateUser();
    } else {
      this.nav.toggleLoading(false);
      await this.updatePassword();
    }
  }

  openChangeLangDialog() {
    const dialogRef = this.dialog.open(ChangeLanguageComponent, {});

    dialogRef.afterClosed().subscribe(result => {
      let option = result.option;
      if (option == "changeLang") {
        this.defaultLang();
      }
    });
  }

  defaultLang() {
    this.cookieService.set('default-language', this.selectedLanguage);
    this.setLanguage(this.selectedLanguage);
  }

  setLanguage(locale) {
    this.siteLocale = locale;
    this.siteLanguage = this.languageList.find(f => f.code === this.siteLocale).label;

    this.base.setLanguage(this.siteLocale);
    this.translate.use(locale);
  }

  submitLang() {
    var lang = this.cookieService.get('default-language');
    if (this.selectedLanguage != lang) {
      this.openChangeLangDialog();
    } else {
      this.openSnackBar(this.translate.instant("PROFILE.ERROR-LANGUAGE"), this.translate.instant("SNACKBAR.DISMISS"))
    }
  }

  openConfirmProfileDeleteDialog() {
    const dialogRef = this.dialog.open(ConfirmProfileDeleteComponent, {});

    dialogRef.afterClosed().subscribe(result => {
      // let option = result.option;
      // if (option == 'changeLang') {

      // }
    });
  }

  async getUserProfileInfo(){
    if (await this.auth.isLoggedIn()) {
      this.nav.toggleLoading(true); // branded loader while the profile data loads
      const user = await this.auth.getUser$();
      const userAttributes = await this.auth.getUserAttribute();

      this.managementService.getUserRequest(user.signInDetails.loginId).subscribe((user) => {
        this.auth.userSubject.next(user);
        let jsonUser = JSON.stringify(user);
        sessionStorage.setItem("user", jsonUser);
        this.managementService.getUserRoles(user.id).subscribe(roles => {
          this.auth.rolesSubject.next(roles);
          let jsonRoles = JSON.stringify(roles);
          sessionStorage.setItem("roles", jsonRoles);
        });

        if (user != null) {
          this.user = user;
          this.personalForm.setValue({ name: user.name, surname: user.surname });
          this.contactForm.setValue({ cell: user.cell });
          this.selectedCurrency = this.user.currency;
          this.selectedLanding = this.user.landingPage;
        }
        this.nav.toggleLoading(false);
      }, () => {
        this.nav.toggleLoading(false);
      });
    }
  }

}
